var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyebrows2E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_x5F_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_x5F_2_2_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.5,244.6c0.2-1.7,1-4.8,0.3-6.5c-0.9-2.1-3.8-2.6-5.7-3.2c-4.7-1.4-9.3-2.5-14.1-3.6c-4.6-1-9.2-1.3-13.8-1.8 c-4.5-0.5-9.6-0.9-13.6,1.5c-4.1,2.4-7.3,5.8-10.6,9.2c-2.3,2.3-0.7,2.8,1.7,2c2.4-0.7,4.5-1.1,7-1.2c9.4-0.6,18.7,1.5,27.9,3.4 c4.2,0.8,8.3,2,12.4,3.1C334.5,248.3,339.5,250.2,339.5,244.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,244.6c-0.2-1.7-1-4.8-0.3-6.5c0.9-2.1,3.8-2.6,5.7-3.2c4.7-1.4,9.3-2.5,14.1-3.6c4.6-1,9.2-1.3,13.8-1.8 c4.5-0.5,9.6-0.9,13.6,1.5c4.1,2.4,7.3,5.8,10.6,9.2c2.3,2.3,0.7,2.8-1.7,2c-2.4-0.7-4.5-1.1-7-1.2c-9.4-0.6-18.7,1.5-27.9,3.4 c-4.2,0.8-8.3,2-12.4,3.1C381.1,248.3,376,250.2,376,244.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyebrows2E);
export default __webpack_public_path__ + "static/media/eyebrows_2e.671e66640f385b40afc52391426fe5ec.svg";
export { ForwardRef as ReactComponent };